/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from "react";

// Context
import AuthContext from "../../authContext";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import { Store } from "../../redux/reducers";
import {
  clearOrderAction,
  getAllOrderItemsAction,
  getOrderWithIdAction,
  updateOrderStatusActions,
  updateOrderActions,
  getLogsAction,
} from "../orders/actions";

// Selector
import { createStructuredSelector } from "reselect";
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectAllOrderItems,
  makeSelectLogs,
} from "../orders/selectors";
import ordersRepository from "client-sdk/src/Repository/orders-repository";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import theme from "../../theme";
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  IconButton,
  Box,
  TextField,
  FormHelperText,
  MenuItem,
} from "@material-ui/core";

// Icon
import Icon from "@mdi/react";
import {
  mdiCalendar,
  mdiStateMachine,
  mdiAccountOutline,
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPhoneOutline,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiIdCard,
  mdiPostOutline,
  mdiKey,
  mdiSendCircleOutline,
  mdiReceipt,
  mdiPaperRollOutline,
  mdiHomeCity,
  mdiCity,
  mdiPackageVariant,
  mdiStoreOutline,
  mdiTextBoxMultipleOutline,
  mdiTableEye,
  mdiMapMarkerCheckOutline,
  mdiPackageVariantClosed,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiTruckFastOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiPackageDown,
  mdiCubeOutline,
  mdiCounter,
  mdiTableRowHeight,
  mdiTableColumnWidth,
  mdiRuler,
} from "@mdi/js";

// Components
import ListOrderItems from "./list";
import InventoryItemsList from "./inventoryItemsList";
import PackageList from "./packagesList";
import Can from "../../components/Can";

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from "../../utils/rulesOrderStatus";

// Helper
import {
  translate,
  formaterPhoneNumber,
  checkHourisPast,
  removeEmptyValueObject,
  disablePrevDateByHour,
  convertPersianDigit2English,
} from "../../utils/helpers";
import jMoment from "moment-jalaali";

// Type
import { Status } from "../orders/interfaces";
import { SelectorProps, Props } from "./interfaces";
import { Link } from "react-router-dom";
import CSV from "./csv";
import { UpdateOrderPostTrackingCode } from "client-sdk/src/orders/orders";
import Client from "client-sdk/src/client";
import handleNotfication from "../../utils/handleNotfication";
import { getInventoryItemsWithSerialAction } from "../parcelLogs/actions";
import Modal from "../../components/Modal";
import { makeSelectInventoryItemsWithSerialList } from "../parcelLogs/selectors";
import JalaliUtils from "@date-io/jalaali";

import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Card } from "@material-ui/core";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@material-ui/lab";
import { CardHeader } from "@material-ui/core";
import InfoCard from "./infocard";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: "36px",
      marginBottom: "36px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
    addIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: "#5c5c5c",
      },
    },
    item: {
      marginBottom: "8px",
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: "scale(-1, 1)",
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 600,
      marginRight: "10px",
      flex: 0.5,
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    submitbtn: {
      border: "none",
      backgroundColor: "#DFA01F",
      padding: "8px",
      color: "#fff",
      borderRadius: "5px",
      fontWeight: 600,
      cursor: "pointer",
      width: "100%",
      "&:hover": {
        backgroundColor: "#c9911e",
      },
    },
    card: {
      marginBottom: "14px",
      overflow: "visible !important",
      padding: "14px",
      // paddingBottom: '0',
      "@media (max-width: 768px)": {
        overflow: "auto",
      },
    },
    contentBox: {
      marginTop: "-1px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "14px",
      fontWeight: 500,
      textAlign: "right",
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: "10px",
      fontWeight: 400,
    },

    missingOppositeContent: {
      "&::before": {
        flex: "none",
      },
    },
    paperHistory: {
      alignItems: "center",
    },
  })
);

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};
const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState("CANCELLED" as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openInventoryItems, setOpenInventoryItems] = useState(
    false as boolean
  );
  const [openPackages, setOpenPackages] = useState(false as boolean);
  const [postTrackingCode, setPostTrackingCode] = useState<null | string>(null);
  const classes = useStyles();
  const token = localStorage.getItem("token") || "";
  const [editMode, setEditMode] = useState(false as boolean);

  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset,
  } = useForm({
    defaultValues: {
      orderType: props.order.orderType,
      deliveryTime: "",
      deliveryStartTime: props.order.deliveryStartTime,
      deliveryEndTime: props.order.deliveryEndTime,
      customerName: "",
      customerMobileNumber: "",
      customerProvince: "",
      customerCity: "",
      customerZipCode: props.order.customerZipCode,
      customerAddress: "",
    },
  });

  const values = getValues();
  const [orderType, setOrderType] = useState<null | string>(
    props.order.orderType
  );
  const [deliveryTypeValue, setDeliveryTypeValue] = useState<null | string>(
    watch("deliveryType")
  );

  const [openDimensions, setOpenDimensions] = useState(false as boolean);

  function getData() {
    const { id } = props.match.params;
    props.getLogsDispatch(id);
    props.orderWithIdActionDispatch(id);
    props.getOrderItemsActionDispatch({
      "orderId.equals": id,
      page: 0,
      size: 1000,
    });
  }
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (props.order?.postTrackingCode) {
      setPostTrackingCode(props.order?.postTrackingCode);
    }
  }, [props.order]);

  useEffect(() => {
    return () => {
      props.clearOrderActionDispatch();
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(props.order)) {
      const {
        orderType,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        description,
        fulfillmentWarehouseId,
        centerId,
        customerLat,
        customerLon,
      } = props.order;
      const payload = {
        orderType,
        deliveryDate,
        deliveryStartTime: deliveryDate + " " + deliveryStartTime,
        deliveryEndTime: deliveryDate + " " + deliveryEndTime,
        deliveryTime:
          deliveryStartTime === "11:00:00"
            ? "11-15"
            : deliveryStartTime === "16:00:00"
            ? "16-20"
            : "",
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        description,
        origin: orderType === "FROM_CENTER" ? centerId : fulfillmentWarehouseId,
        destination: orderType === "TO_CENTER" ? centerId : null,
      };

      const location = {
        lat: Number(customerLat),
        lng: Number(customerLon),
      };

      reset(payload);
    }
  }, [props.order]);

  useEffect(() => {
    if (
      values.deliveryDate &&
      checkHourisPast(
        Number(values.deliveryTime?.substring(0, 2)),
        values.deliveryDate
      )
    )
      setValue("deliveryTime", "");
  }, [values.deliveryDate]);

  const changeStatusOrder = () => {
    const { id } = props.match.params;
    props.updateOrderStatusDispatch({
      id: props.order.id,
      body: previewState.replace(/"/g, ""),
      pagination: {},
      callback: () => props.orderWithIdActionDispatch(id),
    });
    handleClose();
  };

  const handleChangeTrackingCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostTrackingCode(e.target?.value!);
  };

  const submitPostTrackingCode = async () => {
    // @ts-ignore
    try {
      const { id } = props.match.params;
      const makeRequest = new UpdateOrderPostTrackingCode()
        .id(id)
        .data(postTrackingCode)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication("کد پیگیری پست با موفقیت ثبت شد", "success");
      props.orderWithIdActionDispatch(id);
    } catch (err) {
      handleNotfication(
        "تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید",
        "error"
      );
    }
  };

  const handleShowInventoryItems = (data: any) => {
    props.getInventoryItems({
      orderItemId: { equals: data.id },
      callback: () => setOpenInventoryItems(true),
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  const packegeCounter = () => {
    let orders = props.order?.orderPackages.map((el) => el.count);

    if (orders.length > 0) {
      return orders.reduce((acc, curr) => {
        return acc + curr;
      });
    } else {
      return 0;
    }
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      "deliveryDate",
      convertPersianDigit2English(date.format("YYYY-MM-DD"))
    );
    setValue("deliveryTime", "");
  };

  const handleDisableTime = (hour: number) => {
    return (
      checkHourisPast(hour, values.deliveryDate) &&
      props.order.deliveryTypeValue !== "VIP"
    );
  };

  const handleUpdateOrders = (data) => {
    const {
      customerAddress,
      customerCity,
      customerMobileNumber,
      customerName,
      customerProvince,
      deliveryDate: deliver,
      deliveryTime,
    } = data;

    const customerInfo = {
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode: props.order.customerNationalCode,
      customerPhoneNumber: props.order.customerPhoneNumber,
      customerProvince,
      customerZipCode: props.order.customerZipCode,
      customerLat: "",
      customerLon: "",
      customerAddress,
      deliveryType: props.order.deliveryType,
      partnerId: props.order.partnerId,
      orderType: props.order.orderType,
    };
    if (deliver.date) {
      var deliveryDate = convertPersianDigit2English(
        deliver.format("YYYY-MM-DD")
      );
    } else {
      var deliveryDate = deliver;
    }
    const payload = {
      deliveryType: props.order.deliveryType,
      deliveryDate,
      deliveryStartTime:
        deliveryTypeValue !== "VIP"
          ? convertPersianDigit2English(
              deliveryTime.substring(0, 2).concat(":00:00")
            )
          : `${("0" + new Date().getHours()).substr(-2)}:${(
              "0" + new Date().getMinutes()
            ).substr(-2)}`.concat(":00"),
      deliveryEndTime:
        deliveryTypeValue !== "VIP"
          ? convertPersianDigit2English(
              deliveryTime.substring(3, 5).concat(":00:00")
            )
          : `${("0" + (new Date().getHours() + 2)).substr(-2)}:${(
              "0" + new Date().getMinutes()
            ).substr(-2)}`.concat(":00"),
      id: props.match.params.id,
      fulfillmentWarehouseId: props.order.fulfillmentWarehouseId,
    };

    const body = {
      ...removeEmptyValueObject(payload),

      ...removeEmptyValueObject(customerInfo),
    };

    function callback() {
      props.orderWithIdActionDispatch(props.match.params.id);
      setEditMode(false);
    }

    props.updateOrderDispatch({ body, callback });
  };

  const handleCloseDimensions = () => {
    setOpenDimensions(false);
  };

  const [postSize, setPostSize] = useState();
  const [loading, setLoading] = useState(false);

  const addOrderDimensions = async () => {
    try {
      setLoading(true);
      await ordersRepository.addOrderDimensions({
        payload: {
          id: props.order.id,
          body: [{
            count: "1",
            length: "1",
            width: "1",
            height: "1",
            postSize,
          }],
        },
      });
      handleNotfication("تغییر وضعیت سفارش با موفقیت انجام شد", "success");
      handleCloseDimensions();
      getData();
    } catch (error) {
      console.log(error);
      handleNotfication("تغییر وضعیت سفارش انجام نشد", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{props.order.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {"بازگشت"}
        </Button>
        <Grid
          item
          spacing={2}
          style={{ marginLeft: "30px", alignItems: "center" }}
        >
          <Can
            perform="orderExit:print"
            role={authContext.user.role}
            yes={() => (
              <Link
                to={`/orders/exit-receipts/${props.order.id}`}
                target="_blank"
                style={{ textDecoration: "none", margin: "0px 10px" }}
              >
                <Button
                  style={{ marginTop: "-3px" }}
                  variant="contained"
                  color="secondary"
                  startIcon={<Icon path={mdiReceipt} size={1} />}
                >
                  {"چاپ رسید خروج"}
                </Button>
              </Link>
            )}
          />
          <Can
            perform="orderDetail:print"
            role={authContext.user.role}
            yes={() => (
              <Link
                to={`/orders/receipts/${props.order.id}`}
                target="_blank"
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Icon path={mdiPrinter} size={1} />}
                >
                  {authContext.user.role === "WAREHOUSE_OPERATOR" ||
                  authContext.user.role === "WAREHOUSE_ADMIN"
                    ? "چاپ رسید"
                    : "چاپ حواله"}
                </Button>
              </Link>
            )}
          />
          <Button
            style={{ marginLeft: "10px" }}
            variant="contained"
            color="primary"
            startIcon={<Icon path={mdiPackageDown} size={1} />}
            onClick={() => setOpenDimensions(true)}
          >
            {"اضافه کردن بسته"}
          </Button>
          <Can
            role={authContext.user.role}
            perform="orders:downloadReportCSV"
            yes={() => (
              <>
                <CSV
                  // ordersDispatch={props.order}
                  data={props.orderItems}
                  loading={props.loading}
                />
              </>
            )}
          />
        </Grid>
      </Grid>

      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          <Grid container alignItems="center" spacing={4}>
            <Grid
              container
              item
              xs={12}
              sm={12}
              spacing={1}
              alignItems="flex-end"
            >
              <Grid item xs={2}>
                <Icon path={mdiRuler} size={1} />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  id="postSize"
                  name="postSize"
                  value={postSize}
                  onChange={(e) => setPostSize(e.target.value)}
                  label="سایز پستی"
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleCloseDimensions()}
                size="large"
              >
                {"بازگشت"}
              </Button>
            </Grid>
            <Grid item xs={5}>
              <Button
                fullWidth
                autoFocus
                onClick={addOrderDimensions}
                variant="contained"
                color="primary"
                disabled={loading}
                size="large"
              >
                اضافه کردن بسته
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Grid
        container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: "32px", marginTop: "32px" }}
      >
        <InfoCard order={props.order} />
        {/* <Grid item lg={3} md={3} sm={12} xs={12} >
          <form onSubmit={handleSubmit(handleUpdateOrders)}>
            <Card className={classes.card}     >
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'وضعیت تحویل:  '}
                    </span>
                    <Can
                      role={authContext.user.role}
                      perform="orders:changeOrderStatus"
                      yes={() => (
                        <FormControl style={{ width: '100%' }}>
                          <Icon
                            path={mdiPencilOutline}
                            size={1}
                            className={classes.changStatusIcon}
                          />
                          <Select
                            className={classes.changStatusBox}
                            fullWidth
                            inputProps={{
                              name: 'name',
                              id: 'uncontrolled-native',
                            }}
                            name={'status'}
                            id={props.order.rubikaId}
                            value={[{}]}
                            IconComponent={() => null}
                            renderValue={() => (
                              <span className={classes.renderValue}>
                                {translate(props.order.status, 'order')}
                              </span>
                            )}
                          >
                            <RadioGroup
                              className={classes.radioGroup}
                              aria-label={'status'}
                              name={'status$'}
                              value={'item'}
                              onChange={(e: React.ChangeEvent<{ value: unknown }>) =>
                                handleOpenConfirmUpdateState(
                                  `"${e.target.value}"` as Status
                                )
                              }
                            >
                              {rulesOrderStatus[props.order.status]?.map(
                                (item: any, index: number) => (
                                  <FormControlLabel
                                    className={classes.radioGroupItem}
                                    key={index}
                                    checked={props.order.status === item}
                                    value={item}
                                    disabled={
                                      rulesAdminChangeOrderStatus[
                                        authContext.user.role
                                      ].indexOf(item) === -1
                                    }
                                    control={<Radio />}
                                    label={translate(item, 'order')}
                                  />
                                )
                              )}
                            </RadioGroup>
                          </Select>
                        </FormControl>
                      )}
                      no={() => (
                        <span >{translate(props.order.status, 'order')}</span>
                      )}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'نوع ارسال:  '}
                    </span>
                    <span style={{ flex: 1 }}>

                      {translate(props.order?.deliveryType, 'order')}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'کد پیگیری:  '}
                    </span>
                    <span style={{ flex: 1 }}>
                      {props.order?.trackingCode}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'تعداد بسته:  '}
                    </span>
                    <span style={{ flex: 1 }}>
                      {props.order?.orderPackages &&
                        packegeCounter(props.order?.orderPackages)}
                    </span>
                  </div>
                </Grid>
                <Divider className={classes.divider} />
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {' تاریخ ثبت:  '}
                    </span>
                    <span style={{ flex: 1 }}>
                      {props.order.registrationDate &&
                        `${jMoment(props.order.registrationDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'تاریخ تحویل:  '}
                    </span>
                    {editMode ? (
                      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                        <Controller
                          rules={{ required: true }}
                          name="deliveryDate"
                          control={control}
                          as={
                            <DatePicker
                              id="deliveryDate"
                              name="deliveryDate"
                              format="jYYYY/jMM/jDD"
                              minDate={disablePrevDateByHour(16)}
                              disablePast
                              okLabel="تأیید"
                              cancelLabel="لغو"
                              defaultValue={props.order.deliveryDate}
                              value={values.deliveryDate}
                              onChange={handleDeliveryDateChange}
                              error={errors.hasOwnProperty('deliveryDate')}
                              helperText={
                                errors.deliveryDate && errors.deliveryDate.message
                              }
                            />
                          }
                        />
                        <FormHelperText error focused>
                          {errors.deliveryDate && 'تاریخ تحویل سفارش الزامی میباشد'}
                        </FormHelperText>
                      </MuiPickersUtilsProvider>
                    ) : (
                      <span style={{ flex: 1 }}>
                        {props.order.deliveryDate &&
                          `${jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD')}`}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'بازه تحویل:  '}
                    </span>
                    {editMode ? (
                      props.order.deliveryTypeValue !== 'VIP' && (
                        <span style={{ flex: 1 }} >
                          <div className={classes.item}>
                            <div
                              style={{ width: '100%' }}
                              data-cy="deliveryTimePicker"
                            >
                              <Controller
                                rules={{ required: true }}
                                style={{ width: '100%' }}
                                control={control}
                                name="deliveryTime"
                                as={
                                  <TextField
                                    variant="standard"
                                    select
                                    fullWidth
                                    defaultValue={values.deliveryTime}
                                    disabled={props.order.deliveryTypeValue === ''}
                                    error={
                                      !!errors.deliveryTime && !!errors.deliveryTime
                                    }
                                  >
                                    <MenuItem
                                      disabled={handleDisableTime(8)}
                                      value={'11-15'}
                                      data-cy="firstTime"
                                    >
                                      {'11 الی 15'}
                                    </MenuItem>
                                    <MenuItem
                                      disabled={handleDisableTime(13)}
                                      value={'16-20'}
                                      data-cy="secondTime"
                                    >
                                      {'16 الی 20'}
                                    </MenuItem>
                                  </TextField>
                                }
                              />
                              <FormHelperText error focused>
                                {errors?.deliveryTime &&
                                  ' بازه تحویل سفارش الزامی میباشد'}
                              </FormHelperText>
                            </div>
                          </div>
                        </span>
                      )
                    ) : (
                      <span style={{ flex: 1 }}>
                        {`${jMoment(props.order.deliveryStartTime, 'HH:mm:ss')
                          .locale('fa')
                          .format('HH:mm')}`}
                        {` - ${jMoment(props.order.deliveryEndTime, 'HH:mm:ss')
                          .locale('fa')
                          .format('HH:mm')}`}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'استان:  '}
                    </span>
                    {editMode ? (
                      <Controller
                        name="customerProvince"
                        control={control}
                        rules={{
                          required: !!orderType && orderType !== 'TO_CENTER',
                        }}
                        as={
                          <TextField
                            name="customerProvince"
                            variant="standard"
                            defaultValue={formaterPhoneNumber(
                              props.order.customerProvince
                            )}
                          />
                        }
                      />
                    ) : (
                      <span style={{ flex: 1 }}>
                        {formaterPhoneNumber(props.order.customerProvince)}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'شهر:  '}
                    </span>
                    {editMode ? (
                      <Controller
                        name="customerCity"
                        control={control}
                        rules={{
                          required: !!orderType && orderType !== 'TO_CENTER',
                        }}
                        as={
                          <TextField
                            name="customerCity"
                            variant="standard"
                            defaultValue={formaterPhoneNumber(
                              props.order.customerCity
                            )}
                          />
                        }
                      />
                    ) : (
                      <span style={{ flex: 1 }}>{formaterPhoneNumber(props.order.customerCity)}</span>
                    )}
                  </div>
                </Grid>
                <Divider className={classes.divider} />
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'نام:  '}
                    </span>
                    {editMode ? (
                      <Controller
                        name="customerName"
                        control={control}
                        rules={{
                          required: !!orderType && orderType !== 'TO_CENTER',
                        }}
                        as={
                          <TextField
                            name="customerName"
                            variant="standard"
                            defaultValue={props.order.customerName}
                            error={!!errors.customerName && !!errors.customerName}
                          />
                        }
                      />
                    ) : (
                      <span style={{ flex: 1 }}>{props.order.customerName}</span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'شماره همراه:  '}
                    </span>
                    {editMode ? (
                      <Controller
                        name="customerMobileNumber"
                        control={control}
                        rules={{
                          required: !!orderType && orderType !== 'TO_CENTER',
                          minLength: 11,
                          maxLength: 11,
                        }}
                        as={
                          <TextField
                            name="customerMobileNumber"
                            variant="standard"
                            defaultValue={formaterPhoneNumber(
                              props.order.customerMobileNumber
                            )}
                          />
                        }
                      />
                    ) : (
                      <span style={{ flex: 1 }}>
                        {formaterPhoneNumber(props.order.customerMobileNumber)}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'کد ملی:  '}
                    </span>
                    {editMode ? (
                      <Controller
                        name="customerNationalCode"
                        control={control}
                        rules={{
                          required: !!orderType && orderType !== 'TO_CENTER',
                          minLength: 10,
                          maxLength: 10,
                        }}
                        as={
                          <TextField
                            name="customerNationalCode"
                            variant="standard"
                            defaultValue={formaterPhoneNumber(
                              props.order.customerNationalCode
                            )}
                          />
                        }
                      />
                    ) : (
                      <span style={{ flex: 1 }}>
                        {formaterPhoneNumber(props.order.customerNationalCode)}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'آدرس:  '}
                    </span>
                    {editMode ? (
                      <Controller
                        name="customerAddress"
                        control={control}
                        rules={{
                          required: !!orderType && orderType !== 'TO_CENTER',
                          minLength: 10,
                        }}
                        as={
                          <TextField
                            name="customerAddress"
                            fullWidth
                            variant="standard"
                            defaultValue={
                              props.order.customerAddress &&
                              props.order.customerAddress
                            }
                          />
                        }
                      />
                    ) : (
                      <span style={{ flex: 1 }}>
                        {props.order.customerAddress && props.order.customerAddress}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>

                      {'کد پستی:  '}
                    </span>
                    {editMode ? (
                      <Controller
                        name="customerZipCode"
                        control={control}
                        as={<TextField name="customerZipCode" variant="standard" />}
                      />
                    ) : (
                      <span style={{ flex: 1 }}>
                        {formaterPhoneNumber(props.order.customerZipCode)}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {'توضیحات:  '}
                    </span>
                    <span style={{ flex: 1 }}>
                      {props.order.description && props.order.description}
                    </span>
                  </div>
                </Grid>
                <Divider className={classes.divider} />
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <Can
                      role={authContext.user.role}
                      perform="orders:post-tracking-code"
                      yes={() => (
                        <React.Fragment>
                          <TextField
                            id="outlined-basic"
                            value={postTrackingCode}
                            onChange={handleChangeTrackingCode}
                            size={'small'}
                            variant="outlined"
                            placeholder='کد رهگیری پست'
                            fullWidth
                          />
                          <Button
                            style={{ marginRight: '5px' }}
                            variant="contained"
                            color="secondary"
                            onClick={submitPostTrackingCode}
                            disabled
                            size={'medium'}
                          >{`ثبت`}</Button>
                        </React.Fragment>
                      )}
                      no={() => <span style={{ flex: 1 }}>{props.order?.postTrackingCode}</span>}
                    />
                  </div>
                </Grid>
                {props.order.postOrders &&
                  props.order.postOrders.map((postOrder, index) => {
                    return (
                      <Can
                        role={authContext.user.role}
                        perform="orders-detail:postOrders"
                        yes={() => (
                          <Grid
                            item
                            container
                            xs={12}
                          >
                            <Grid item xs={12} >
                              <div className={classes.item}>
                                <span className={classes.label}>
                                  {'شناسه مرسوله:  '}
                                </span>
                                <span style={{ flex: 1 }}>{postOrder.id && postOrder.id}</span>
                              </div>
                            </Grid>
                            <Grid item xs={12} >
                              <div className={classes.item}>
                                <span className={classes.label}>
                                  {'کد رهگیری پست:  '}
                                </span>
                                <span style={{ flex: 1 }}>
                                  {postOrder.barcode && postOrder.barcode}
                                </span>
                              </div>
                            </Grid>
                          </Grid>
                        )}
                      />
                    );
                  })}
                <Divider className={classes.divider} />
                <Grid item xs={12}>
                  <div>
                    {editMode ? (
                      <input
                        type="submit"
                        value={'ثبت تغییرات'}
                        className={classes.submitbtn}
                      />
                    ) : (
                      <Button
                        fullWidth
                        onClick={() => setEditMode(true)}
                        color="primary"
                        size="medium"
                        variant="contained"
                      >
                        تغییر سفارش
                      </Button>
                    )}
                  </div>
                </Grid>

              </Grid>
            </Card>
          </form>
        </Grid> */}
        <Grid item lg={9} md={9} sm={12} xs={12} spacing={2}>
          {props.order?.items && (
            <Card>
              <Grid>
                <ListOrderItems
                  data={props.orderItems}
                  showItems={(data) => handleShowInventoryItems(data)}
                />
              </Grid>
            </Card>
          )}
          <Card style={{ marginTop: "16px" }}>
            <Grid item xs={12}>
              <Timeline align="left" style={{ minWidth: "500px" }}>
                {props.logs
                  ?.slice()
                  .reverse()
                  .map((log, index: number) => (
                    <TimelineItem
                      className={classes.missingOppositeContent}
                      key={index}
                    >
                      <TimelineSeparator>
                        <TimelineDot
                          style={{
                            backgroundColor: colorStatus[log.newStatus],
                            border: index === 0 ? "solid 4px #DF9234" : "",
                          }}
                        >
                          <Icon path={iconStatus[log.newStatus]} size={1} />
                        </TimelineDot>
                        {index !== props.logs?.length - 1 ? (
                          <TimelineConnector />
                        ) : (
                          ""
                        )}
                      </TimelineSeparator>
                      <TimelineContent className={classes.paperHistory}>
                        <div style={{ padding: "10px" }}>
                          <div className={classes.contentBox}>
                            <div style={{ flex: 1.5, textAlign: "right" }}>
                              <span className={classes.contentlabel}>
                                وضعیت سفارش:
                              </span>
                              <span data-cy="status">
                                {translate(log.newStatus, "order")}
                              </span>
                            </div>
                            <div
                              style={{
                                flex: 2,
                                textAlign: "right",
                                justifyContent: "center",
                              }}
                            >
                              <span className={classes.contentlabel}>
                                کاربر:
                              </span>
                              <Can
                                role={authContext.user.role}
                                perform="user-name:dontShowInLogs"
                                no={() => (
                                  <>
                                    <span>{log.modifierName}</span>
                                    <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                                  </>
                                )}
                              />
                              <span data-cy="role">
                                {translate(log.modifierRole, "user")}
                              </span>
                            </div>
                            <Typography component="div" style={{ flex: 1 }}>
                              {log.time &&
                                jMoment(log.time, "YYYY/MM/DDTHH:mm:ss.SSZ")
                                  .locale("fa")
                                  .format("jYYYY/jMM/jDD - HH:mm")}
                            </Typography>
                          </div>
                        </div>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
              </Timeline>
            </Grid>
          </Card>
        </Grid>
      </Grid>

      <Modal
        onClose={() => setOpenInventoryItems(false)}
        maxWidth="md"
        open={openInventoryItems}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiStoreOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<InventoryItemsList data={props.inventoryItems} />}
      />

      <Modal
        maxWidth="xl"
        onClose={() => setOpenPackages(false)}
        open={openPackages}
        title={
          <div style={{ textAlign: "center" }}>
            <Icon
              path={mdiTextBoxMultipleOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<PackageList data={props.order?.postOrders} />}
      />

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(props.order.status, "order")}"
        به
       " ${translate(previewState.replace(/"/g, "") as Status, "order")}"


        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {"خیر"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large"
              >
                {"بله"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  order: makeSelectOrder(),
  orderItems: makeSelectAllOrderItems(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsWithSerialList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
    clearOrderActionDispatch: () => dispatch(clearOrderAction()),
    getInventoryItems: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
    getOrderItemsActionDispatch: (payload: any) =>
      dispatch(getAllOrderItemsAction(payload)),
    updateOrderDispatch: (payload) => {
      dispatch(updateOrderActions(payload));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
